/* Bootstrap popovers */
$('[data-toggle="popover"]').popover();

